export default __webpack_public_path__ + "static/media/date.5c954589.svg";